import { AlertTriangle, RefreshCw } from "lucide-react";
import { errorMessage } from "../lib/format";

export function PageLoader({ label = "กำลังโหลดข้อมูลปฏิบัติการ" }: { label?: string }) {
  return <div className="page-loader" role="status"><span className="loader-rail"><i /></span><p>{label}</p></div>;
}

export function PageError({ error, retry }: { error: unknown; retry?(): void }) {
  return (
    <div className="empty-state empty-state--error" role="alert">
      <AlertTriangle size={25} />
      <div><h3>โหลดข้อมูลไม่สำเร็จ</h3><p>{errorMessage(error)}</p></div>
      {retry ? <button className="button button--secondary" type="button" onClick={retry}><RefreshCw size={16} />ลองอีกครั้ง</button> : null}
    </div>
  );
}

export function EmptyState({ title = "ยังไม่มีข้อมูล", description = "เมื่อมีรายการใหม่ ระบบจะแสดงที่นี่" }: { title?: string; description?: string }) {
  return <div className="empty-state"><div className="empty-state__glyph" aria-hidden="true">00</div><div><h3>{title}</h3><p>{description}</p></div></div>;
}
